import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Target } from "lucide-react";
import { ChildPerformanceCard } from "@/components/parent/ChildPerformanceCard";
import { useParentData } from "@/hooks/useParentData";

export default function ParentAnalysis() {
  const { children, loading } = useParentData();

  return (
    <div className="container mx-auto px-4 py-8">
      <header className="mb-6">
        <h1 className="text-3xl font-bold">Analysis</h1>
        <p className="text-muted-foreground">Performance breakdown for each of your children.</p>
      </header>
      <Card>
        <CardHeader>
          <CardTitle>Children's Performance Analysis</CardTitle>
          <CardDescription>View detailed performance metrics for each child</CardDescription>
        </CardHeader>
        <CardContent>
          {loading ? (
            <p className="text-muted-foreground">Loading…</p>
          ) : children.length > 0 ? (
            <div className="grid gap-6 md:grid-cols-2">
              {children.map((child) => (
                <ChildPerformanceCard key={child.id} childName={child.student_name} childEmail={child.student_email} />
              ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <Target className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">
                No children added yet. Add children to view their performance analysis.
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
